import { Component, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { FeatureCollection, Geometry } from 'geojson';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-upload-kml-file',
  standalone: false,
  templateUrl: './upload-kml-file.component.html',
  styleUrl: './upload-kml-file.component.scss',
})
export class UploadKmlFileComponent implements OnInit {
  public form: FormGroup;
  public wrongSchema$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private fileReader = new FileReader();

  public constructor(private readonly parentFormGroup: FormGroupDirective) {}

  public ngOnInit(): void {
    this.form = this.parentFormGroup.control;
  }

  public onSelectedFile(file: File) {
    this.fileReader.onload = () => {
      try {
        const base64StringFile = this.fileReader.result
          ?.toString()
          .replace(/^data:(.*,)?/, '');
        const jsonString = atob(base64StringFile);
        const geoJson: FeatureCollection<Geometry> = JSON.parse(jsonString);

        if (this.validateGeoJsonSchema(geoJson)) {
          this.wrongSchema$.next(false);
          this.form.get('geoJsonFile')?.setErrors({});
          this.form.get('geoJsonFile')?.setValue(base64StringFile);
        } else {
          this.wrongSchema$.next(true);
          this.form.get('geoJsonFile')?.setErrors({ schemaFail: true });
        }
      } catch (e) {
        this.wrongSchema$.next(true);
        this.form.get('geoJsonFile')?.setErrors({ schemaFail: true });
      }
    };
    if (file === null) {
      this.wrongSchema$.next(false);
      this.form.get('geoJsonFile')?.setErrors({});
      this.form.get('geoJsonFile')?.setValue('');
    } else {
      this.fileReader.readAsDataURL(file);
    }
  }

  private validateGeoJsonSchema(data: FeatureCollection<Geometry>): boolean {
    if (!data || typeof data !== 'object') return false;
    if (data.type !== 'FeatureCollection' || !Array.isArray(data.features))
      return false;

    for (const feature of data.features) {
      if (
        feature.type !== 'Feature' ||
        !feature.geometry ||
        !feature.properties
      )
        return false;

      const { geometry } = feature;
      if (!geometry || !Array.isArray((geometry as Geometry)['coordinates']))
        return false;
    }

    return true;
  }
}
